import { z } from 'zod';

const apiErrorObjectSchema = z.object({
    data: z.object({
        error: z.string(),
    }),
});

const messageErrorSchema = z.object({
    message: z.string(),
});

// Extract error message safely from unknown
export const extractApiErrorMessage = (err: unknown): string => {
    const apiResult = apiErrorObjectSchema.safeParse(err);
    if (apiResult.success) return apiResult.data.data.error;

    const msgResult = messageErrorSchema.safeParse(err);
    if (msgResult.success) return msgResult.data.message;

    return 'Unknown error';
};
